export const SEARCH_BY_FILED = {
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
};
export const SEARCH_BY = [SEARCH_BY_FILED.NAME, SEARCH_BY_FILED.PHONE, SEARCH_BY_FILED.EMAIL];

export const SEARCH_LEVEL = {
  GLOBAL: 'global',
  CLIENT_LIST: 'clientList',
};
